import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { MatDialog } from '@angular/material';
import { AztecScannerDialogComponent } from '../../../components/dialogs/aztec-scanner-dialog/aztec-scanner-dialog.component';
import {InternalConfigService} from '../../../services/internal-config.service';
import {DeviceService} from '../../../services/device.service';

@Component({
  selector: 'app-aztec-section',
  templateUrl: './aztec-section.component.html'
})
export class AztecSectionComponent extends SectionBase implements OnInit {

  sectionVisible: boolean;

  constructor(public dialog: MatDialog,
    public deviceService: DeviceService,
    private internalConfigService: InternalConfigService) {
    super();
  }

  ngOnInit() {
    this.initSectionVisible();
    this.initBean();
  }

  public createConfig(): void {
  }

  public initBean(): void {
    this.bean = {};
  }

  public initControlsChanges(): void {
  }

  public openAztecReader(): void {
    this.dialog.open(AztecScannerDialogComponent);
  }

  public isSectionValid(): boolean {
    return true;
  }

  public get valid(): boolean {
    return true;
  }

  public submitSection(): void {
    // section hasn't form to submit
  }

  private initSectionVisible(): void {
    this.sectionVisible = this.internalConfigService.resolveSectionVisibility('additionalContentSection');
  }
}
